import {
  logRedirectProcessingStart,
  logRedirectResultAnalysis,
} from "../../../utils/core/debugUtils";
import { handleRedirectPrompt } from "./redirectPromptHandlers";
import { handleRedirectCompletion } from "./redirectCompletionHandlers";
import { handleRedirectCommand } from "./redirectExecutionHandlers";

/**
 * Processes the redirect command result and handles prompt/output display
 * @param {Object} redirectResult - The result from the redirect command
 * @param {Object} params - Parameters object containing callbacks and setters
 */
export async function processRedirectResult(redirectResult, params) {
  const {
    resolvePrompt,
    onStepStart,
    onCommandComplete,
    onCommandStart,
    initMessage,
    setters,
    engine,
    nextCommandName,
  } = params;

  logRedirectProcessingStart();
  logRedirectResultAnalysis(redirectResult);

  console.log("🔍 Redirect result analysis:", {
    hasPrompt: !!redirectResult.prompt,
    hasOutput: !!redirectResult.output,
    hasError: !!redirectResult.error,
    hasNextCommand: !!redirectResult.nextCommand,
    promptValue: redirectResult.prompt,
    outputValue: redirectResult.output,
    fullResult: redirectResult,
  });

  if (redirectResult.prompt) {
    console.log("✅ Redirect has prompt - calling handleRedirectPrompt");
    await handleRedirectPrompt(
      redirectResult.prompt,
      resolvePrompt,
      nextCommandName,
      onStepStart,
      onCommandStart
    );
  } else if (redirectResult.nextCommand) {
    // The redirected command itself has a redirect - continue the chain
    console.log(
      "🔄 Redirect result has nextCommand - chaining redirect to:",
      redirectResult.nextCommand
    );
    // Recursively handle the next redirect
    const nestedRedirectResult = await handleRedirectCommand(
      redirectResult,
      engine,
      nextCommandName
    );
    await processRedirectResult(nestedRedirectResult, params);
  } else {
    console.log(
      "❌ Redirect has no prompt and no nextCommand - calling handleRedirectCompletion"
    );
    await handleRedirectCompletion(redirectResult, {
      setters,
      engine,
      initMessage,
      onCommandComplete,
      nextCommandName,
    });
  }
}
